var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSealcoin16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-192)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,2)",
    d: "m168-2c-1.1153-1e-7 -1.4598 1.5615-2.4902 1.9883-1.0304 0.4268-2.3774-0.43316-3.166 0.35547-0.78863 0.78862 0.0713 2.1356-0.35547 3.166-0.4268 1.0304-1.9883 1.375-1.9883 2.4902 0 1.1153 1.5615 1.4598 1.9883 2.4902s-0.43316 2.3774 0.35547 3.166c0.78862 0.78862 2.1356-0.07133 3.166 0.35547 1.0304 0.4268 1.375 1.9883 2.4902 1.9883 0.27625 0 0.50518-0.09547 0.70898-0.24609-1.0455-0.91824-1.709-2.2619-1.709-3.7539 0-2.7496 2.2504-5 5-5 1.492 0 2.8357 0.66352 3.7539 1.709 0.15062-0.2038 0.24609-0.43274 0.24609-0.70898 0-1.1153-1.5615-1.4598-1.9883-2.4902s0.43316-2.3774-0.35547-3.166c-0.78862-0.78863-2.1356 0.071332-3.166-0.35547-1.0304-0.4268-1.375-1.9883-2.4902-1.9883z",
    fill: "#ff8080",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 3c-2.7496 0-5 2.2504-5 5 0 2.4372 1.7692 4.4809 4.0859 4.9141-0.05551-0.29688-0.08594-0.60173-0.08594-0.91406 0-0.04658 3e-3 -0.09239 4e-3 -0.13867a4 4 0 0 1-3.004-3.8613 4 4 0 0 1 4-4 4 4 0 0 1 3.8711 3.0039c0.04305-0.0011092 0.08561-0.0039062 0.12891-0.0039062 0.31233 0 0.61718 0.030429 0.91406 0.085937-0.43315-2.3167-2.4768-4.0859-4.9141-4.0859z",
    color: "#000000",
    fill: "#fff",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 12a4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4z",
    color: "#000000",
    fill: "#d4aa00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.69 9.0371a0.50005 0.50005 0 0 0-0.54493 0.10938l-2.5 2.5 0.70704 0.70703 1.6465-1.6465v4.293h1v-5.5a0.50005 0.50005 0 0 0-0.30859-0.46289z",
    color: "#000000",
    fill: "#fff",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealcoin16);
export default __webpack_public_path__ + "static/media/seal.coin.16.cb01f3db4da2652523828f8c52ced766.svg";
export { ForwardRef as ReactComponent };